import { ROLE_CODES } from "Common/Constants";
import { SysBrewAuthProvider, useSysBrewAuth } from "SysBrewAuthProvider";

const AUTH_TOKEN = "auth_token"

const getToken = () => localStorage.getItem(AUTH_TOKEN)
const removeToken = () => localStorage.removeItem(AUTH_TOKEN)

const AuthProvider = ({ children }) => {

    return (
        <SysBrewAuthProvider>
            {children}
        </SysBrewAuthProvider>
    )
}

const throwError = hook => {
    throw new Error(`${hook} must be used within a AuthProvider`)
}

const useAuth = () => {
    const { user, isLoading, error, isAuthenticated, logout: authLogout, token } = useSysBrewAuth()

    if (user === undefined) throwError("useAuth")

    const clearSession = () => {
        removeToken()
    }

    const logout = () => {
        clearSession()
        authLogout({ returnTo: window.location.origin })
    }

    const isAdmin = () => {
        if (!user.roles) return false
        return Array.isArray(user.roles) ? user.roles.includes(ROLE_CODES.ADMIN) : user.roles === ROLE_CODES.ADMIN
    }

    const isAdminOrManager = () => {
        if (!user.roles) return false
        return Array.isArray(user.roles)
            ? user.roles.includes(ROLE_CODES.ADMIN) || user.roles.includes(ROLE_CODES.MANAGER)
            : (user.roles === ROLE_CODES.ADMIN || user.roles === ROLE_CODES.MANAGER)
    }

    return {
        isLoading,
        error,
        isAuthenticated,
        logout,
        clearSession,
        getAccessToken: token,
        user,
        isAdmin: isAdmin(),
        isAdminOrManager: isAdminOrManager(),
        branches: user.branches,
    }
}

export { AuthProvider, useAuth, getToken }